import React from 'react';
import Hero from 'components/hero';
import FancyButton from 'components/fancy-button';
import { ReactComponent as Connection } from 'svg/illustrations/undraw_hire_te5y.svg';
import './style.css';

const EmployerHero = () => {
  return (
    <Hero className="employer-hero" layout="horizontal">
      <div>
        <h1>
          MyShifts enables employers, in the Health and Care Sector, to easily
          find temporary workers and &apos;connect&apos; with each other in a
          direct way
        </h1>
        <p>
          &apos;no middle people&apos;. It is a service that is operated for the
          people who use it. You could say it is a national &apos;Bank
          Worker&apos; database. One new &apos;BIG&apos; marketplace. It is
          aimed at revolutionising the way &apos;agency&apos; work is organised
          and funded.
        </p>
        <FancyButton href="/signup/isEmployer">Sign up Now</FancyButton>
      </div>
      <Connection className="home-illustration" />
    </Hero>
  );
};

export default EmployerHero;
